(ns manage.export-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :as adset-queries]
            [common.util :refer [format-timestamp]]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui format-type
  [{:keys [type]}]
  (case type
    "direct" "Direct export"
    "manual" "Manual export"
    type))

(defui format-sizes
  [{:keys [sizes]}]
  ($ Stack {:direction "row"
            :alignItems "center"
            :spacing 1}
     (for [size sizes]
       ($ Chip {:key (str (:width size) "x" (:height size))
                :label (str (:width size) "x" (:height size))}))))

(def Toolbar
  (uix/as-react
   (fn []
     ($ dg/grid-toolbar
        {:hide-quick-filter true
         :sx #js {:justifyContent "flex-end"}}
        ($ Button
           {:onClick #(rf/dispatch [:ocp/open {:id :adset/export}])
            :variant "contained"}
           "Export")))))

(def columns
  #js [#js {:field "createdAt"
            :headerName "Export time"
            :width 150
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:createdAt row))
            :renderCell (fn [^js params]
                          (format-timestamp (.-value params)))}
       #js {:field "type"
            :headerName "Export type"
            :width 120
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:type row))
            :renderCell (fn [^js params]
                          ($ format-type {:type (.-value params)}))}
       #js {:field "exportName"
            :headerName "Export name"
            :width 200
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:exportName row))}
       #js {:field "adserverAccountName"
            :headerName "Adserver"
            :width 150
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:adserverAccountName row))}
       #js {:field "templateExports"
            :headerName "Sizes"
            :width 200
            :flex 1
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:templateExports row))
            :renderCell (fn [^js params]
                          ($ format-sizes {:sizes (.-value params)}))}])

(defn get-row-id [row] (:exportId row))

(defui export-data-grid []
  (let [{:keys [adset-id]} (use-subscribe [:url-context])
        {exports :data isPending :isPending} (use-query (adset-queries/adset-exports-history-query {:adset-id adset-id}))

        on-row-click (uix/use-callback (fn [^js params]
                                         (let [export (.-row params)]
                                           (rf/dispatch [:modal/open {:id :page.export-display/last-export-result
                                                                      :props {:export-result export}}])))
                                       [])

        page-size 10]
    ($ DataGridPremium
       {:columns columns
        :loading isPending
        :rows (to-array exports)
        :getRowId get-row-id
        :onRowClick on-row-click
        :data-testid "export-table"
        :checkboxSelection false
        :disableRowSelectionOnClick true
        :pagination true
        :pageSizeOptions #js [page-size]
        :localeText #js {:noRowsLabel "This adset has not been exported yet"}
        :initialState #js {:pagination #js {:paginationModel #js {:pageSize page-size}}}
        :slots #js {:row dg/WithDynamicPropsRow
                    :cell dg/WithDynamicPropsCell
                    :toolbar Toolbar}
        :slotProps #js {:row #js {:get-props-fn (fn [{:keys [row]}]
                                                  {:data-testid (:exportName row)})}
                        :cell #js {:get-props-fn (fn [{:keys [^js column]}]
                                                   {:data-testid (.-field column)})}}
        :sx #js {:maxHeight "70rem"
                 "& .MuiDataGrid-row:hover" #js {:cursor "pointer"}}})))
